export class ApiUrls {
    public static LOGIN_URL: string = '/api/auth/login';
    public static REGISTER_URL: string = '/api/register';

    //driver
    public static FETCH_DRIVERS: string = '/api/drivers';
    public static FETCH_DRIVERS_PAGINATION: string = '/api/drivers/paged';
    public static ADD_DRIVER: string = '/api/drivers';
    public static GET_DRIVER: string = '/api/drivers';
    public static UPDATE_DRIVER: string = '/api/drivers';
    public static DELETE_DRIVER: string = '/api/drivers';
    public static FETCH_DRIVERS_BY_COMPANY: string = '/api/driver/by-company';

    //user
    public static FETCH_LOGBOOKERS: string = '/api/users/logbookers';
    public static FETCH_USERS: string = '/api/users';
    public static FETCH_USERS_PAGINATION: string = '/api/users/paged';
    public static ADD_USER: string = '/api/users';
    public static GET_USER: string = '/api/users';
    public static UPDATE_USER: string = '/api/users';
    public static DELETE_USER: string = '/api/users';
    public static USER_AVATAR: string = '/api/users';

    //role
    public static FETCH_ROLES: string = 'api/roles';
    public static ADD_ROLE: string = '/api/roles';
    public static GET_ROLE: string = '/api/roles';
    public static UPDATE_ROLE: string = '/api/roles';
    public static DELETE_ROLE: string = '/api/roles';

    //level
    public static FETCH_LEVELS: string = '/api/levels';
    public static ADD_LEVEL: string = '/api/levels';
    public static GET_LEVEL: string = '/api/levels';
    public static UPDATE_LEVEL: string = '/api/levels';
    public static DELETE_LEVEL: string = '/api/levels';

    //checker
    public static FETCH_CHECKER_TASKS: string = '/api/checker-tasks/filter';
    public static ADD_CHECKER_TASK: string = '/api/checker-tasks';
    public static GET_CHECKER_TASK: string = '/api/checker-tasks';
    public static UPDATE_CHECKER_TASK: string = '/api/checker-tasks';
    public static DELETE_CHECKER_TASK: string = '/api/checker-tasks';
    public static CHECKER_TASK_UPLOADS: string = '/api/checker-tasks';

    //company
    public static FETCH_COMPANIES: string = 'api/companies';
    public static FETCH_COMPANIES_PAGINATION: string = 'api/companies/paged';
    public static ADD_COMPANY: string = '/api/companies';
    public static GET_COMPANY: string = '/api/companies';
    public static UPDATE_COMPANY: string = '/api/companies';
    public static DELETE_COMPANY: string = '/api/companies';

    //note
    public static BASE_NOTE: string = '/api/note';

    //statement
    public static STATEMENT_PORTAL_USERS: string = '/api/statement/portal-users';
    public static STATEMENT_ROWS: string = '/api/statement/rows';

    //task
    public static TASK_MAIN_API: string = 'api/route-task';
    public static TASK_QUERY: string = 'api/route-task/query';
    public static TASK_QUEUE: string = 'api/route-task/queue';
    public static TASK_HISTORY: string = 'api/route-task';

    // assistant
    public static ADD_ASSISTANT: string = 'api/route-task/add-assistant';
    public static UPDATE_ASSISTANT: string = 'api/route-task/update-assistant'; 

    //task-management
    public static ADD_TASK_MANAGEMENT: string = '/api/task-management';
    public static PROCESS_TASK_MANAGEMENT: string = '/api/task-management/process';
    public static ASSISTANT_PROCESS_TASK_MANAGEMENT: string = '/api/task-management/assistant-process';

    //statistics
    public static GET_ALL_LOG_BOOKER_STATISTICS = '/api/statistics/logbookers';
    public static GET_LOG_BOOKER_STATISTICS = '/api/statistics/logbooker';
    public static GET_ALL_STATISTICS = '/api/statistics/logbookers/filter';
    public static GET_STATISTICS_ACTORS = '/api/statistics/actors';
    public static GET_STATISTICS_ALL_ACTORS = '/api/statistics/all-actors';

    // monitoring
    public static MONITORING_URL = '/api/monitoring';

    // kpi
    public static KPI_URL = '/api/logbooker-summaries';
    public static KPI_STATISTIC_URL = '/api/logbooker-summaries/statistics';

    // driver activiites
    public static DRIVER_ACTIVITES = '/api/driver-activities';
    public static DRIVER_ACTIVITES_FILTER = '/api/driver-activities/filter';
    public static DRIVER_ACTIVITIES_HISTORY = '/api/driver-activities/history';
    public static DRIVER_ACTIVITIES_COLUMN = '/api/driver-activities/custom-column';

    // sales
    public static SALES_TASKS_URL = '/api/sales-tasks';
    public static GET_SALES_TASKS_URL = '/api/sales-tasks/filter';

    // device
    public static DEVICE_TASKS_URL = '/api/device-tasks';
    public static GET_DEVICE_TASKS_URL = '/api/device-tasks/filter';

    // contracts
    public static CONTRACTS_URL = '/api/contracts';

    // inspections
    public static INSPECTIONS_URL = '/api/inspections';

    // kpi calculation (points system)
    public static KPI_CALC_SETTINGS = '/api/kpi/settings';
    public static KPI_CALC_NOTE_POINT_RULES = '/api/kpi/note-point-rules';
    public static KPI_CALC_SALARIES = '/api/kpi/salaries';
    public static KPI_SALARY_HISTORY = '/api/kpi/salary-history';
    public static KPI_CALC_ADJUSTMENTS = '/api/kpi/adjustments';
    public static KPI_CALC_STATISTICS = '/api/kpi/statistics';
    public static MY_KPI_STATISTICS = '/api/my-kpi/statistics';

    // sales kpi (separate from the points-based kpi)
    public static SALES_KPI_SETTINGS = '/api/sales-kpi/settings';
    public static SALES_KPI_SALARIES = '/api/sales-kpi/salaries';
    public static SALES_KPI_STATISTICS = '/api/sales-kpi/statistics';
    public static SALES_KPI_EMPLOYEE = '/api/sales-kpi/employee';

    // company / driver entry-exit statistics
    public static COMPANY_DRIVER_STATS = '/api/company-driver-stats/statistics';
    public static COMPANY_DRIVER_STATUS = '/api/company-driver-stats/status';

    // attendance (Clockster integration)
    public static ATTENDANCE_SYNC = '/api/attendance/sync';
    public static ATTENDANCE_MAPPING = '/api/attendance/mapping';
    public static ATTENDANCE_STATISTICS = '/api/attendance/statistics';
    public static ATTENDANCE_IGNORED = '/api/attendance/ignored';
}
